import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const OFFERS_URL =
    (import.meta.env.VITE_APP_OFFERS_URL as string | undefined) ??
    "https://www.mailvista.ai/tarifs";

const OffersButton = () => {
    const { t } = useTranslation();

    return (
        <Button
            className="w-full"
            onClick={() =>
                window.open(OFFERS_URL, "_blank", "noopener,noreferrer")
            }
            size="lg"
            variant="purpleGradient"
        >
            {t("noLicense.public.cta")}
            <ArrowRight className="h-4 w-4" />
        </Button>
    );
};

export default OffersButton;
